/**
 * config.js — all values come from Vite env vars.
 */
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://api.heet7studio.com'
export const WEB_BASE_URL = import.meta.env.VITE_WEB_BASE_URL || 'https://demo.divinetechnologies.in'

if (!API_BASE_URL) {
  console.error('[config] VITE_API_BASE_URL is not set — copy .env.example to .env')
}

const config = {
  api: { baseUrl: API_BASE_URL },
  web: { baseUrl: WEB_BASE_URL },
}

export default config
